import { motion } from "framer-motion";

export default function SilentUX() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative py-24 md:py-36"
    >
      <div className="mx-auto max-w-5xl px-6 md:px-10">
        <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
          <span className="h-px w-8 bg-black/40" />
          Silent UX
        </div>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          data-testid="philosophy-paragraph"
          className="mt-6 text-3xl sm:text-4xl md:text-5xl leading-[1.1] tracking-[-0.035em] text-[#0A0A0A] font-medium"
        >
          Fittin is designed to{" "}
          <span className="text-neutral-400">stay out of the way.</span>
          {" "}It appears only when needed, delivers{" "}
          <span className="text-neutral-400">instant clarity,</span>
          {" "}and disappears again — creating a frictionless shopping experience.
        </motion.p>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            ["0 MB", "Added weight"],
            ["<60 ms", "Render budget"],
            ["1 line", "Script tag"],
            ["0", "Dark patterns"],
          ].map(([k, v]) => (
            <div key={v} className="border-t border-black/10 pt-4">
              <div className="text-2xl tracking-tight font-medium">{k}</div>
              <div className="mt-1 text-[12px] uppercase tracking-[0.18em] text-neutral-500">
                {v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
